// extracted by mini-css-extract-plugin
module.exports = {"socialIcons":"bio-module--social-icons--1Vw55"};